module.exports = __webpack_public_path__ + "static/img/product5.9c59792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/black/product5.png
// module id = lRrD
// module chunks = 0